import React from 'react';
import styled from 'styled-components';

/**
 *
 * @returns {스크립트 레이아웃}
 */
interface IProps {
  children: JSX.Element[] | JSX.Element;
}
const ScriptLayout: React.FC<IProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ScriptLayout;

const Container = styled.div`
  max-width: 100vw;
  min-width: 100vw;
  background-color: burlywood;
`;
